import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../../components/button/Button';
import { FlyoutFooter } from '../../../../components/flyout-components/FlyoutFooter';
import { DealerInput } from '../../../../components/form-elements/DealerInput';
import { DeliveryAddressesTable } from '../../../../shared/components/DeliveryAddressesTable';
import { ShipToAddressRead, ShipToAddressWithOrders } from '../../../../shared/models/ship-to-address-read';
import { DealerSvc } from '../../../../shared/services/dealer-service';
import { StatusCode } from '../../../../utils/api';
import { TransportationUtils } from '../../../helpers';
import { ShipmentActionType } from '../../../models/enums/shipment-action-type';
import { DeliveryShipmentActionCreateFull } from '../../../models/shipments/shipment-action-create-full';

interface IProps {
    onSave: any;
    onCancel: any;
    truckId: number;
    truckVersion: string;
    serviceCenterId: string;
    onAdvancedEdit: any|undefined;
}

export const CreateCustomerDeliveryStepOne = (props : IProps) => {

    const dispatch = useDispatch();
    const [service] = React.useState(new DealerSvc());

    const [dealerId, setDealerId] = React.useState<string>('');
    const [addressList, setAddressList] = React.useState<ShipToAddressRead[]>([]);
    const [shipTo, setShipTo] = React.useState<ShipToAddressRead>();
    const [fullAddressList, setFullAddressList] = React.useState<ShipToAddressWithOrders[]>([]);

    /**
     * Handle the dealer changing by kicking off a search for addresses
     * @param e the dealer ID
     */
    const onDealerChange = async (e : any) => {

        if (e) {
            setDealerId(e.id);

            const result = await service.getDealerAddressesWithOrders(e.id, props.serviceCenterId);
            if (result.status === StatusCode.Success) {

                const justsAddresses = result.data.reduce((addrList : ShipToAddressRead[], current : ShipToAddressWithOrders) => {
                    addrList.push(current.shipToAddress);
                    return addrList;
                }, []);

                setAddressList(justsAddresses);
                setFullAddressList(result.data);
            }
        }
    };

    /**
     * Updated the selected address
     * @param itm The ShipTo Address the user selected
     */
    const onAddressSelected = (itm : ShipToAddressRead) => {
        if (itm && TransportationUtils.isValidAddress(itm.address)) {
            setShipTo(itm);
        }
        else {
            setShipTo(undefined);
        }
    };

    const bundleForAdvanced = () => {
        
        if (!shipTo?.id) {
            return;
        }

        const newStop = new DeliveryShipmentActionCreateFull();
        newStop.type = ShipmentActionType.Delivery;
        newStop.dealerId = dealerId;
        newStop.shipToAddressId = shipTo?.id;
        newStop.rowVersion = props.truckVersion;
        newStop.address = shipTo;

        const fullVM = fullAddressList.find((itm : ShipToAddressWithOrders) => {
            return itm.shipToAddress.id === newStop.shipToAddressId;
        });

        if (fullVM) {
            newStop.openOrders = fullVM.orders;
        }

        props.onAdvancedEdit(newStop);
        
    };

    return <div className="stop-create-content">

                <div className="row">
                    <div className="col-md-2">
                        <h2 className="step-label">Step<br/>1</h2>
                    </div>
                    <div className="col-md-10">
                        <h3 className="step-instruction">Pick a dealer</h3>
                        <DealerInput
                            id="dealerLookup"
                            label=""
                            dispatch={ dispatch }
                            onChange={ onDealerChange}
                            value={ dealerId } />
                    </div>
                </div>
                
                {
                    dealerId.length > 0
                        ? <div className="row">
                            <div className="col-md-2">
                                <h2 className="step-label">Step<br/>2</h2>
                            </div>
                            <div className="col-md-10">
                                <h3 className="step-instruction">Pick an address</h3>
                                <div className="address-list-wrapper">
                                    <DeliveryAddressesTable
                                        addresses={ addressList }
                                        dealerId={ dealerId }
                                        enableLink={ false }
                                        onClick={ onAddressSelected }
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }
                                           
                <FlyoutFooter>
                    <div className="row">
                        <div className="col">                            
                            <Button
                                text="Add Orders &gt;"
                                testID="wizard-step-one-ok-button"
                                disable={ !shipTo }
                                onBtnClick={ bundleForAdvanced } />
                        </div>
                        <div className="col">
                            <Button
                                text="Cancel"
                                id="stop-content-cancel-button"
                                testID="wizard-step-one-cancel-button"
                                onBtnClick={ props.onCancel } />
                        </div>
                    </div>
                </FlyoutFooter>
  
            </div>;
};
